// removed by extract-text-webpack-plugin
module.exports = {"form":"_3XJes3LrPPYlw_Z0FFbseF"};


//////////////////
// WEBPACK FOOTER
// ./src/views/wizard/susc-results/opt/style.css
// module id = 853
// module chunks = 0